import React, { useCallback, useEffect, useState, useRef } from "react";
import { Button } from "antd";
import Webcam from "react-webcam";

/**
 * CameraCapture component
 * Props:
 *  - onCapture(imageSrc): returns the captured image (base64)
 *  - label: custom label for the capture button
 */
const CameraCapture = ({ onCapture, label = "Capture Photo" }) => {
  const webcamRef = useRef(null);
  const [image, setImage] = useState(null);
  const [devices, setDevices] = useState([]);

  // Get available video devices (front/back camera, etc.)
  const handleDevices = useCallback(
    (mediaDevices) => {
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput"));
    },
    [setDevices]
  );

  useEffect(() => {
    navigator.mediaDevices
      .enumerateDevices()
      .then(handleDevices)
      .catch((err) => console.error("Error fetching devices:", err));
  }, [handleDevices]);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    if (onCapture) onCapture(imageSrc);
  };

  const retake = () => {
    setImage(null);
    if (onCapture) onCapture(null);
  };

  return (
    <div style={{ textAlign: "center" }}>
      {image ? (
        <>
          <img
            src={image}
            alt="Captured"
            style={{
              width: "100%",
              borderRadius: "8px",
              marginBottom: "10px",
            }}
          />
          <Button onClick={retake} type="default">
            Retake
          </Button>
        </>
      ) : (
        <>
          <Webcam
            ref={webcamRef}
            audio={false}
            screenshotFormat="image/jpeg"
            width="100%"
            videoConstraints={{
              deviceId: devices[0]?.deviceId,
              facingMode: "user",
            }}
            style={{
              borderRadius: "8px",
              marginBottom: "10px",
            }}
          />
          <Button onClick={capture} type="primary">
            {label}
          </Button>
        </>
      )}
    </div>
  );
};

export default CameraCapture;
